<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Update Employee Attendance Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                  <br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <!-- <p><b>Employee List</b></p> -->
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" hint="Please Select Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <!-- <p><b>Employee List</b></p> -->
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list" item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <!-- <p><b>Date</b></p> -->
                        <v-text-field outlined rounded dense type="date" label="Date" v-model="fromdate"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="fromdate && employee">
                    <v-btn color="warning" @click="fetchEmployeeAttendanceDetails()">Fetch Attendance Details</v-btn>
                </v-row>
                <br />
            </v-card>
             <v-card class="box" v-if="employee_attendance_details.length!=''">
        <v-data-table :headers="headers" :items="employee_attendance_details">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Attendance Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.freezeattendance`]="{ item }">
              <v-switch
                v-model="item.freezeattendance"
                @change="saveFreezeUnfreezeAttendance(item)"
              ></v-switch>
          </template>
          <!-- <template v-slot:[`item.intime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.intime"
            ></v-text-field>
          </template> -->
          <!-- <template v-slot:[`item.outtime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.outtime"
            ></v-text-field>
          </template> -->
          <!-- <template v-slot:[`item.expectedintime`]="{ item }">
            <v-text-field
              outlined
              dense
              type="time"
              v-model="item.expectedintime"
            ></v-text-field>
          </template> -->
          <template v-slot:[`item.isweeklyoff`]="{ item }">
             <span v-if="item.isweeklyoff">
                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
        
        </v-data-table>
      </v-card> 
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            employee_list: [],
            fromdate: new Date().toISOString().slice(0, 10),
            employee: "",
            show_detail_card: false,
            change_inout: false,
            employee_attendance_details: [],
            ay_list:[],ay:"",
            headers: [
                { text: "Sr No", value: "count" },
                { text: "Employee", value: "name" },
                { text: "Employee Type", value: "employeetype" },
                { text: "Section", value: "employeepaymentsection" },
                { text: "Expected Intime", value: "expectedintime" },
                { text: "Expected Outtime", value: "expectedouttime" },
                { text: "Expected No Of Hours", value: "expectednoofhours" },
                { text: "Intime", value: "intime" },
                { text: "Outtime", value: "outtime" },
                { text: "Is Weeklyoff", value: "isweeklyoff" },
                { text: "Holiday", value: "holidaydetails" },
                { text: "Is Attendance Freezed?", value: "freezeattendance" },
            ],
        }),
        methods: {
            removeLeave(item) {
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/removeLeave", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Leave Removed Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            clearIntime(item) {
                console.log("clear Intime");
                console.log(item.id);
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/clearIntime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            clearOutTime(item) {
                const data = {
                    employee_attendance_id: item.id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/clearOutTime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            saveFreezeUnfreezeAttendance(item) {
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_freezeattendance: item.freezeattendance,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveUpdateFreezeUnfreezeAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            saveIsnonWorkingDay(item) {
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_isnonworkingday: item.isnonworkingday,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveIsnonWorkingDay", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },

            deleteHoliday(item) {
                const data = {
                    holidays: item.holiday_id,
                    instructors: item.instructor_id,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/deleteHolidays", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Updated Successfully...");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        // this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetchEmployeeAttendanceDetails();
                    });
            },
            updateEmployeeAttendanceDetails(item) {
                const data = {
                    employee_attendance: item,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/updateEmployeeAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            saveUpdateWeeklyOff(item) {
                if (item.freezeattendance == true) {
                    this.showSnackbar("red", "Cannot Update As Attendance Is Freezed..");
                    return;
                }
                //return
                const data = {
                    employee_attendance_id: item.id,
                    employee_attendance_weeklyoff: item.isweeklyoff,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveUpdateWeeklyOff", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            fetchEmployeeAttendanceDetails() {
                const data = {
                    employee: this.employee,
                    fromdate: this.fromdate,
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/fetchEmployeeAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_attendance_details = res.data.employee_attendance_details;
                            this.change_inout = res.data.change_inout;
                            this.show_detail_card = true;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.master_present = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                this.overlay = true;
                this.loader = true;
                axios
                    .post("/EmployeeBiometric/upateEmployeeAttendanceDetailsHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.employee_list;
                            this.ay_list = res.data.ay_list;
                            this.ay = res.data.cay;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    input[type="time"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
        color: #0f2027;
    }

    /* css for switch  */
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 4px;
    }
</style>
